'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _createReducer;

exports.clearFeedbackError = clearFeedbackError;
exports.showModalFeedback = showModalFeedback;
exports.hideModalFeedback = hideModalFeedback;
exports.sendFeedback = sendFeedback;
exports.setModalStatus = setModalStatus;

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reduxImmutablejs = require('redux-immutablejs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_MODAL_FEEDBACK = 'karmapa-digital-toolbox/feedback/SHOW_MODAL_FEEDBACK';
var HIDE_MODAL_FEEDBACK = 'karmapa-digital-toolbox/feedback/HIDE_MODAL_FEEDBACK';

var SEND_FEEDBACK = 'karmapa-digital-toolbox/feedback/SEND_FEEDBACK';
var SEND_FEEDBACK_SUCCESS = 'karmapa-digital-toolbox/feedback/SEND_FEEDBACK_SUCCESS';
var SEND_FEEDBACK_FAIL = 'karmapa-digital-toolbox/feedback/SEND_FEEDBACK_FAIL';

var SET_MODAL_STATUS = 'karmapa-digital-toolbox/feedback/SET_MODAL_STATUS';

var CLEAR_FEEDBACK_ERROR = 'karmapa-digital-toolbox/feedback/CLEAR_FEEDBACK_ERROR';

var initialState = _immutable2.default.Map({
  done: false,
  isModalVisible: false,
  isSendingFeedback: false,
  sendFeedbackError: null
});

exports.default = (0, _reduxImmutablejs.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, SHOW_MODAL_FEEDBACK, function (state) {
  return state.set('isModalVisible', true);
}), (0, _defineProperty3.default)(_createReducer, HIDE_MODAL_FEEDBACK, function (state) {
  return state.set('isModalVisible', false);
}), (0, _defineProperty3.default)(_createReducer, SEND_FEEDBACK, function (state) {
  return state.set('isSendingFeedback', true);
}), (0, _defineProperty3.default)(_createReducer, SEND_FEEDBACK_SUCCESS, function (state) {
  return state.set('isSendingFeedback', false);
}), (0, _defineProperty3.default)(_createReducer, SEND_FEEDBACK_FAIL, function (state, action) {
  return state.set('isSendingFeedback', false).set('sendFeedbackError', action.error);
}), (0, _defineProperty3.default)(_createReducer, SET_MODAL_STATUS, function (state, action) {
  return state.set('done', action.done);
}), (0, _defineProperty3.default)(_createReducer, CLEAR_FEEDBACK_ERROR, function (state) {
  return state.set('sendFeedbackError', null);
}), _createReducer));
function clearFeedbackError() {
  return {
    type: CLEAR_FEEDBACK_ERROR
  };
}

function showModalFeedback() {
  return {
    type: SHOW_MODAL_FEEDBACK
  };
}

function hideModalFeedback() {
  return {
    type: HIDE_MODAL_FEEDBACK
  };
}

function sendFeedback(data) {
  return {
    types: [SEND_FEEDBACK, SEND_FEEDBACK_SUCCESS, SEND_FEEDBACK_FAIL],
    promise: function promise(client) {
      return client.post('/feedbacks/send', { data: data });
    }
  };
}

function setModalStatus(done) {
  return {
    type: SET_MODAL_STATUS,
    done: done
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/feedback.js
 ** module id = 547
 ** module chunks = 0
 **/